import headers from './components/headers.vue'
import footers from './components/footers.vue'
import hero from './components/hero.vue'
import breadcrumb from './components/breadcrumb.vue'
import swiper from './components/swiper.vue'
import carousel from './components/carousel.vue'
import blogcard from './components/blogcard.vue'
import staffcard from './components/staffcard.vue'
import slice from './components/slice.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        headers: headers,
        footers: footers,
        hero: hero,
        breadcrumb: breadcrumb,
        swiper: swiper,
        carousel: carousel,
        blogcard: blogcard,
        staffcard: staffcard,
        slice: slice,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
